module.exports = __webpack_public_path__ + "static/media/pasteBlue.1e631a14.svg";